module.exports = __webpack_public_path__ + "static/media/wonton-soup.d0dca10a.jpg";